module.exports = __webpack_public_path__ + "img/装车单.7c8dff53.svg";